import React from 'react';
import { connect } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    videoPreviewIframe: {
        overflow: 'hidden'
    },
    progress: {
        width: 60,
        height: 60,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
        display: 'none'
    }
});

const CatalogVideoPlayer = (props) => {
    const { classes, catalogVideoPreviewData } = props;

    return (!catalogVideoPreviewData) ? null : (
        <>
            <CircularProgress 
                className={classes.progress} 
            />
            <iframe 
                className={classes.videoPreviewIframe}
                src={catalogVideoPreviewData.urls.exampleUrl} 
                width='910' 
                height='510' 
                frameBorder='0' 
                allow='autoplay; fullscreen; picture-in-picture' 
                allowFullScreen 
                title='Specterr Catalog Video'
            >
            </iframe>
        </>
    );
};

const mapStateToProps = (state) => {
    const { catalogVideoPreviewData } = state.mediaPicker;
    return { catalogVideoPreviewData };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CatalogVideoPlayer, styles));